
export class DataFormatters {

  /**
   * Converts a Date object to a YYYY-MM-DD string, respecting the local timezone.
   *
   * This method uses the local date components (getFullYear, getMonth, getDate)
   * to prevent the timezone conversion issues that occur with `toISOString()`.
   *
   * @param {date} date The Date object to format. Handles falsy values (null, undefined) by returning an empty string.
   * @return {string} The formatted date string (e.g., "2025-11-07") or an empty string if the input date is falsy.
   */
  public static toLocalYYYYMMDD(date: Date): string {

    if (!date) return ''

    const year = date.getFullYear()
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  /**
   * Determines the appropriate store code to display on the UI based on its content.
   * If the store code contains at least one letter (e.g., 'GT001'), it returns the original store code.
   * If the store code only contains numbers (e.g., '00003'), it falls back to the numeric code.
   *
   * @param {string | undefined} storeCode - The primary alphanumeric or numeric store code.
   * @param {number} storeNumericCode - The fallback numeric code for the store.
   * @return {string} The correct display code for the store.
   */
  public static getDisplayCode(storeCode: string | undefined, storeNumericCode: number): string | number {
    const hasLetters = /[a-zA-Z]/.test(storeCode || '')
    return hasLetters ? (storeCode || '') : storeNumericCode
  }

}
